import { render, staticRenderFns } from "./DiagnoseResultView.vue?vue&type=template&id=07a3aada&scoped=true"
import script from "./DiagnoseResultView.vue?vue&type=script&lang=js"
export * from "./DiagnoseResultView.vue?vue&type=script&lang=js"
import style0 from "./DiagnoseResultView.vue?vue&type=style&index=0&id=07a3aada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a3aada",
  null
  
)

export default component.exports